<div class="taskManager-page width_100" fxLayoutGap="20px" fxLayout="column" fxLayoutAlign="start center">
    <form [formGroup]="transactionsForm" class="width_100" *ngIf="globalService.isMobile$.getValue()">
        <div fxFlex="100" fxLayout="row" fxLayoutAlign="start center">
            <div class="filter_section width_100" fxLayout="row" fxLayoutAlign="start center">
                <mat-form-field class="filter_1" appearance="outline" fxLayoutAlign="start center">
                    <mat-icon matPrefix>search</mat-icon>
                    <input formControlName="name" matInput placeholder="Search" #input
                        (keyup)="searchFilter($event.target.value)">
                    <button type="button" class="search_button" (click)="resetFilter()" *ngIf="searchValue">
                        <i class="material-icons">close</i>
                    </button>
                </mat-form-field>
            </div>
        </div>
    </form>
    <div class="width_100 position_relative" fxLayout="row" fxLayoutAlign="start center">
        <mat-tab-group fxFlex="100">
            <mat-tab>
                <ng-template mat-tab-label>
                    <div fxLayoutAlign="start center" fxLayoutGap="5px">
                        <div id="all_transactions">All Tasks</div>
                    </div>
                </ng-template>
                <div class="cleaning_detail_container">
                    <div fxFlex="100" fxLayoutGap="20px" fxLayout="column" fxLayoutAlign="start start">
                        <div class="cleaning_filter width_100" fxLayout="row" fxLayoutAlign="start center"
                            *ngIf="!globalService.isMobile$.getValue()">
                            <form [formGroup]="transactionsForm" class="width_100" fxLayout="row" fxLayoutGap="10px"
                                fxLayoutAlign="space-between center">
                                <div class="filter_searchBox" fxLayoutAlign="start center">
                                    <div class="filter_section" fxLayout="row" fxLayoutAlign="start center">
                                        <mat-form-field class="filter_1" appearance="outline"
                                            fxLayoutAlign="start center">
                                            <mat-icon matPrefix>search</mat-icon>
                                            <input formControlName="name" matInput placeholder="Search" #input
                                                (keyup)="searchFilter($event.target.value)">
                                            <button type="button" class="search_button" (click)="resetFilter()"
                                                *ngIf="searchValue">
                                                <i class="material-icons">close</i>
                                            </button>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="filter_Box" fxLayout="row" fxLayoutGap="10px"
                                    fxLayoutAlign="flex-end center">
                                    <div (click)="resetFilter()"
                                        [class.clear_filter_section-hidden]="!isValueInFilterForm"
                                        class="clear_filter_section cursor_pointer" fxLayoutGap="5px" fxLayout="row"
                                        fxLayoutAlign="start center">
                                        <div>Clear filter</div>
                                        <mat-icon [svgIcon]="'refresh'"></mat-icon>
                                    </div>
                                    <div class="filter_section servicetype dropdownCustom" fxLayout="row"
                                        fxLayoutAlign="start center">
                                        <app-select #responsiblePerson placeholder="Responsible Person"
                                            [value]="responsiblePerson.value"
                                            (selectionChange)="filter.responsiblePersonName=$event;applyFilter()"
                                            [selectOptions]="responsiblePersonsList" [valueField]="'firstName'"
                                            [labelField]="'fullName'">
                                        </app-select>
                                    </div>
                                    <div class="filter_section paymentstatus dropdownCustom" fxLayout="row"
                                        fxLayoutAlign="start center">
                                        <app-select #department placeholder="Department" [value]="department.value"
                                            (selectionChange)="filter.departmentName = $event; applyFilter()"
                                            [selectOptions]="departmentList" [valueField]="'text'"
                                            [labelField]="'text'">
                                        </app-select>
                                    </div>
                                    <div class="filter_section transactionStatus dropdownCustom" fxLayout="row"
                                        fxLayoutAlign="start center">
                                        <app-select #priority placeholder="Priority" [value]="priority.value"
                                            (selectionChange)="filter.priority=$event;applyFilter()"
                                            [selectOptions]="priorityList" [valueField]="'text'" [labelField]="'text'">
                                        </app-select>
                                    </div>
                                    <div class="filter_section transactionStatus dropdownCustom" fxLayout="row"
                                        fxLayoutAlign="start center">
                                        <app-select #taskStatus placeholder="Task Status" [value]="taskStatus.value"
                                            (selectionChange)="filter.statusName = $event;applyFilter()"
                                            [selectOptions]="taskStatusList" [valueField]="'text'"
                                            [labelField]="'displayName'">
                                        </app-select>
                                    </div>
                                    <span>
                                        <div class="button-section" fxLayout="center center" (click)="createTask()">
                                            <div fxLayoutAlign="space-between center">
                                                <mat-icon>add</mat-icon>
                                                Create Task
                                            </div>
                                        </div>
                                    </span>
                                </div>
                            </form>
                        </div>

                        <!--*ngIf="transactions && transactions.length > 0"-->
                        <div class="cleaning_body_container width_100" fxLayout="column" fxLayoutGap="30px"
                            fxLayoutAlign="center center">
                            <div class="request_list width_100">
                                <mat-table #taskTable="matSort" [dataSource]="dataSource" matSort class="width_100"
                                    matSortDisableClear>
                                    <ng-container matColumnDef="id">
                                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                                            Task ID
                                        </mat-header-cell>
                                        <mat-cell mat-cell *matCellDef="let element"
                                            (click)="openTaskDetail(element.id)">{{element.id}}
                                        </mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="taskName">
                                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                                            Title
                                        </mat-header-cell>
                                        <mat-cell *matCellDef="let element" (click)="openTaskDetail(element.id)">
                                            {{element.taskName}} </mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="departmentName">
                                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                                            Department
                                        </mat-header-cell>

                                        <mat-cell *matCellDef="let element" (click)="openTaskDetail(element.id)">
                                            {{
                                             !element.departmentName || element.departmentName === 'Other' ||
                                            element.departmentName === 'Others'
                                            ? 'Pending Assignment'
                                            : element.departmentName
                                            }}
                                        </mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="responsiblePerson">
                                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                                            Responsible Person
                                        </mat-header-cell>

                                        <mat-cell *matCellDef="let element" fxLayout="column"
                                            fxLayoutAlign="center start" style="padding-right: 30px;">
                                            <mat-form-field appearance="outline" class="responsible-select">
                                                <mat-select [(ngModel)]="element.responsiblePerson"
                                                    (selectionChange)="onResponsibleChange(element)"
                                                    placeholder="Select Responsible Person">
                                                    <mat-option *ngFor="let person of responsiblePersonsList"
                                                        [value]="person.userId">
                                                        {{ person.firstName }} {{ person.lastName }}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="priority">
                                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                                            Priority
                                        </mat-header-cell>
                                        <mat-cell *matCellDef="let element" style="justify-content: center;"
                                            fxLayout="column" fxLayoutAlign="center center"
                                            (click)="openTaskDetail(element.id)">
                                            <div class="order_status" fxLayout="row" fxLayoutAlign="start center"
                                                style="align-self: start;">
                                                <div *ngIf="element.tmProPriorityId==1"> Low </div>
                                                <div *ngIf="element.tmProPriorityId==2"> Medium </div>
                                                <div *ngIf="element.tmProPriorityId==3"> High </div>
                                                <div *ngIf="element.tmProPriorityId==4"> Important </div>
                                            </div>
                                        </mat-cell>

                                    </ng-container>
                                    <ng-container matColumnDef="toBeDoneBy">
                                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                                            Due Date
                                        </mat-header-cell>
                                        <mat-cell *matCellDef="let element"
                                            [ngStyle]="{ 'color': isOverdue(element) && element.statusName!='Closed' ? '#D9480F' : '' }"
                                            (click)="openTaskDetail(element.id)">
                                            {{getDisplayDate(element.toBeDoneBy)}}
                                        </mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="escalated">
                                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                                            Escalated
                                        </mat-header-cell>
                                        <mat-cell *matCellDef="let element" (click)="openTaskDetail(element.id)">
                                            <div *ngIf="element.isEscalate==false">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="11.915" height="14.409"
                                                    viewBox="0 0 11.915 14.409" style="margin-right: 5px;">
                                                    <path id="flag-variant"
                                                        d="M5.794,3a.8.8,0,0,1,.794.8v.7a8.464,8.464,0,0,1,3.177-.7c2.383,0,2.383,1.6,3.972,1.6a3.438,3.438,0,0,0,3.177-1.6v6.4a3.438,3.438,0,0,1-3.177,1.6c-2.383,0-2.383-1.6-3.972-1.6a3.438,3.438,0,0,0-3.177,1.6v5.6H5V3.8A.8.8,0,0,1,5.794,3Z"
                                                        transform="translate(-5 -3)" fill="#00be26" />
                                                </svg>
                                            </div>
                                            <div *ngIf="element.isEscalate==true">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="11.915" height="14.409"
                                                    viewBox="0 0 11.915 14.409" style="margin-right: 5px;">
                                                    <path id="flag-variant"
                                                        d="M5.794,3a.8.8,0,0,1,.794.8v.7a8.464,8.464,0,0,1,3.177-.7c2.383,0,2.383,1.6,3.972,1.6a3.438,3.438,0,0,0,3.177-1.6v6.4a3.438,3.438,0,0,1-3.177,1.6c-2.383,0-2.383-1.6-3.972-1.6a3.438,3.438,0,0,0-3.177,1.6v5.6H5V3.8A.8.8,0,0,1,5.794,3Z"
                                                        transform="translate(-5 -3)" fill="#d9480f" />
                                                </svg>
                                            </div>
                                            {{escalateStatus(element.isEscalate)}}
                                        </mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="statusName">
                                        <mat-header-cell *matHeaderCellDef mat-sort-header
                                            style="justify-content: center;">
                                            Task Status
                                        </mat-header-cell>
                                        <mat-cell *matCellDef="let element" (click)="openTaskDetail(element.id)"
                                            style="justify-content: center;">
                                            <div class="transaction_status" fxLayout="row" fxLayoutAlign="start center"
                                                [ngClass]="element.statusName=='In work'?'In-Work':element.statusName">
                                                <div style="margin:0 auto">
                                                    {{globalService.getDisplayStatus(element.statusName)}}</div>
                                            </div>
                                        </mat-cell>
                                    </ng-container>
                                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                    <tr mat-row [ngClass]="{'highlightRow': row?.statusName === 'Open'}"
                                        *matRowDef="let row; columns: displayedColumns;">
                                    </tr>
                                </mat-table>
                                <mat-paginator #taskListDataPaginator (page)="handlePageEvent($event)"
                                    [pageSizeOptions]="[10, 25, 50]" [pageIndex]="pageIndex"
                                    *ngIf="!(globalService.isMobile$ | async)" showFirstLastButtons
                                    aria-label="Select page of periodic elements">
                                </mat-paginator>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>